import axios from "axios";
import { api } from "./api_client";

export type RegionData = {
  starting_location: {
    lat: number;
    lon: number;
  };
  regions: [
    {
      name: string;
      emoji: string;
      code: string;
    }
  ];
};

export default async function fetchRegions(
  signal?: AbortSignal
): Promise<RegionData> {
  try {
    const response = await api.get<RegionData>(`/regions`, {
      signal,
    });
    return response.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request aborted");
    } else {
      console.error("Error fetching data:", error);
    }

    throw error;
  }
}
